import React, { useEffect, useRef } from 'react';

import { SliderInput } from '@sravni/react-design-system';
import type { SliderInputProps } from '@sravni/react-design-system/dist/types/components/SliderInput';

import { useDisableScrollWhenUseSlider } from '../lib';

/**
 * Временный костыль чтобы не ждать когда это пофиксят в react-design-system
 */
export const SliderInputWithDisabledScroll = (props: SliderInputProps) => {
  const sliderWrapper = useRef<HTMLDivElement>(null);
  const slider = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!sliderWrapper.current) return;

    slider.current = sliderWrapper.current.querySelector('[data-qa="Slider"]');
  }, []);

  useDisableScrollWhenUseSlider(slider.current);

  return (
    <div ref={sliderWrapper}>
      <SliderInput {...props} />
    </div>
  );
};
